import { useFormContext } from 'react-hook-form';

import type { AddItemSetQuestionConditionsFormType } from './add-item-set-question-conditions-schema';

export const useAddItemSetQuestionConditionsFormContext =
  useFormContext<AddItemSetQuestionConditionsFormType>;
